//#region src/redux/modal-view/thunk-types.ts
var thunkTypes = {
	HIDE_MODAL_VIEW: `modalView/hideModalView`,
	REVEAL_MODAL_VIEW: `modalView/revealModalView`,
	UPDATE_MODAL_VIEW: `modalView/updateModalView`
};
//#endregion
export { thunkTypes };

//# sourceMappingURL=thunk-types.js.map